export const SETTINGS = {
  indicators: {
    'tax-treaty-status': [
      'In effect',
      'Awaits ratification',
      'Awaits signature',
      'In negotiation'
    ]
  },
  variables: {
    'dividends': {
      label: 'Dividends'
    },
    'interest': {
      label: 'Interest'
    },
    'royalties': {
      label: 'Royalties'
    },
    'management-fee': {
      label: 'Management Fee'
    }
  }
}

export default SETTINGS



// WEBPACK FOOTER //
// ./src/utils/settings.js